import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Layout from './layouts/DashboardLayout';
//import './vibe/scss/styles.scss';
import './views/scss/nhp.scss';

export default function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route component={Layout} />
      </Switch>
    </BrowserRouter>
  );
}
